var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopsPageShop5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 115,
    viewBox: "0 0 248 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 226,
    height: 93,
    rx: 10,
    fill: "#050624"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 58.72H85.32C85.464 59.2 85.696 59.624 86.016 59.992C86.72 60.824 87.768 61.24 89.16 61.24C91.24 61.24 92.28 60.6 92.28 59.32C92.28 59 92.168 58.712 91.944 58.456C91.736 58.2 91.4 57.976 90.936 57.784C90.488 57.592 90.048 57.44 89.616 57.328C89.2 57.2 88.656 57.048 87.984 56.872C87.888 56.856 87.808 56.84 87.744 56.824C87.696 56.808 87.624 56.792 87.528 56.776C87.448 56.744 87.376 56.72 87.312 56.704C83.984 55.904 82.32 54.296 82.32 51.88C82.32 50.44 82.904 49.224 84.072 48.232C85.256 47.224 86.832 46.72 88.8 46.72C91.36 46.72 93.296 47.584 94.608 49.312C95.152 50.08 95.536 50.936 95.76 51.88H92.04C91.944 51.544 91.76 51.224 91.488 50.92C90.88 50.28 89.984 49.96 88.8 49.96C87.888 49.96 87.2 50.136 86.736 50.488C86.272 50.824 86.04 51.248 86.04 51.76C86.04 52.688 87.096 53.392 89.208 53.872C89.752 54 90.088 54.08 90.216 54.112C90.36 54.144 90.688 54.232 91.2 54.376C91.728 54.52 92.08 54.64 92.256 54.736C92.448 54.816 92.76 54.952 93.192 55.144C93.64 55.32 93.952 55.488 94.128 55.648C94.32 55.808 94.56 56.024 94.848 56.296C95.152 56.552 95.368 56.816 95.496 57.088C95.624 57.36 95.736 57.68 95.832 58.048C95.944 58.4 96 58.784 96 59.2C96 60.688 95.4 61.944 94.2 62.968C93 63.976 91.32 64.48 89.16 64.48C86.312 64.48 84.224 63.52 82.896 61.6C82.272 60.768 81.84 59.808 81.6 58.72ZM98.6437 64V47.2H102.244V53.8H109.684V47.2H113.284V64H109.684V57.16H102.244V64H98.6437ZM116.649 64V47.2H129.249V50.56H120.249V53.92H127.449V57.04H120.249V60.64H129.249V64H116.649ZM132.007 64V47.2H135.607V64H132.007ZM138.973 64V47.2H143.653L150.253 59.08H150.493L150.253 57.04V47.2H153.853V64H149.173L142.573 52.12H142.333L142.573 54.16V64H138.973Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 248,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopsPageShop5);
export default __webpack_public_path__ + "static/media/shopsPage_shop5.34b879b0bae2cea12b9979f1d5ebd199.svg";
export { ForwardRef as ReactComponent };